'use strict';
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('org/content/customerServicesSidebar'));
    processInclude(require('org/content/modulesCarousels'));
    processInclude(require('pagedesigner/videoVimeo'));
});
